import api from './api';

export interface Equipment {
  id: number;
  customer_id: number;
  name: string;
  type: string;
  brand?: string;
  model?: string;
  serial_number?: string;
  location?: string;
  status: 'active' | 'inactive' | 'maintenance' | 'retired';
  installation_date?: string;
  purchase_date?: string;
  warranty_expiry?: string;
  last_maintenance_date?: string;
  next_maintenance_date?: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  // Relations
  customer?: {
    id: number;
    email: string;
    customerProfile?: {
      first_name: string;
      last_name: string;
      phone?: string;
    };
  };
}

export interface EquipmentsResponse {
  success: boolean;
  data: {
    equipments: Equipment[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

const equipmentsService = {
  async getAll(params?: { customer_id?: number; status?: string; type?: string; page?: number; limit?: number }) {
    return api.get<EquipmentsResponse>('/equipments', { params });
  },
  async getById(id: number) {
    return api.get<{ success: boolean; data: Equipment }>(`/equipments/${id}`);
  },
  async create(data: Partial<Equipment>) {
    return api.post<{ success: boolean; data: Equipment }>('/equipments', data);
  },
  async update(id: number, data: Partial<Equipment>) {
    return api.put<{ success: boolean; data: Equipment }>(`/equipments/${id}`, data);
  },
  async remove(id: number) {
    return api.delete<{ success: boolean; message: string }>(`/equipments/${id}`);
  }
};

export default equipmentsService;
